/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum TopicColumnsToSort {
    NAME = 'NAME',
    OUT_OF_SYNC_REPLICAS = 'OUT_OF_SYNC_REPLICAS',
    TOTAL_PARTITIONS = 'TOTAL_PARTITIONS',
    REPLICATION_FACTOR = 'REPLICATION_FACTOR',
    SIZE = 'SIZE'
}

export function TopicColumnsToSortFromJSON(json: any): TopicColumnsToSort {
    return TopicColumnsToSortFromJSONTyped(json, false);
}

export function TopicColumnsToSortFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopicColumnsToSort {
    return json as TopicColumnsToSort;
}

export function TopicColumnsToSortToJSON(value?: TopicColumnsToSort | null): any {
    return value as any;
}

